import type { SanityBlock } from '@sanity/client';

const ACCORDION_TYPES = new Set(['accordeon', 'accordeonComponent', 'accordionList']);

export interface BlockRun {
  key: string;
  isAccordions: boolean;
  blocks: SanityBlock[];
}

/** TextWithImage gaps every item in its column, so consecutive accordions are grouped into one. */
export const groupAccordionRuns = (blocks: SanityBlock[] = []): BlockRun[] =>
  blocks.reduce<BlockRun[]>((runs, block, index) => {
    const isAccordions = ACCORDION_TYPES.has(block._type);
    const last = runs[runs.length - 1];

    if (last?.isAccordions === isAccordions) {
      last.blocks.push(block);
    } else {
      runs.push({ key: block._key ?? String(index), isAccordions, blocks: [block] });
    }
    return runs;
  }, []);
